export default __webpack_public_path__ + "static/media/judith.0b1752b5.jpeg";